import React, { createContext, useContext, ReactNode } from 'react';

interface AuthContextType {
  token: string | null;
  handleLogin: (accessToken: string, refreshToken?: string) => void;
  handleLogout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
  token: string | null;
  handleLogin: (accessToken: string, refreshToken?: string) => void;
  handleLogout: () => void;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({
  children,
  token,
  handleLogin,
  handleLogout,
}) => {
  return (
    <AuthContext.Provider value={{ token, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
